/** Build board URL from returnTo / returnView query of the cycle page. */
export function boardReturnHref(returnTo, returnView = null) {
    if (returnTo) {
        const decoded = safeDecode(returnTo);
        if (isSafeEngagementPath(decoded))
            return decoded;
    }
    if (returnView === 'projects') {
        return '/engagements/projects';
    }
    if (returnView === 'bt' ||
        returnView === 'profile' ||
        returnView === 'contract') {
        return `/engagements?view=${returnView}`;
    }
    return '/engagements?view=bt';
}
function safeDecode(value) {
    try {
        return decodeURIComponent(value);
    }
    catch {
        return value;
    }
}
function isSafeEngagementPath(path) {
    if (!path.startsWith('/engagements'))
        return false;
    if (path.startsWith('//') || path.includes('://'))
        return false;
    return true;
}
/** Relative board URL (path + query) to restore after the cycle page. */
export function boardReturnToParam(pathWithQuery) {
    return encodeURIComponent(pathWithQuery);
}
